import React from 'react';
import { cn } from '@/lib/utils';
import booksGif from '/src/assets/booksGif.gif';
import loadingGif from '/src/assets/loadingGif.gif';

interface LoadingMessageBubbleChatbotProps {
  mode: 'chatbot' | 'recommender';
}

const LoadingMessageBubbleChatbot = React.memo(function LoadingMessageBubbleChatbot({
  mode,
}: LoadingMessageBubbleChatbotProps) {
  const loadingMessage = mode === 'chatbot' 
    ? 'Buscando información...' 
    : 'Analizando tu perfil...';
  
  const gifSrc = mode === 'chatbot' ? booksGif : loadingGif;
  const gifSize = mode === 'chatbot' ? 'w-14' : 'w-10';

  return (
    <div className="flex w-full justify-start animate-in fade-in-50 duration-300">
      <div className="flex flex-col items-start max-w-[80%]">
        <div className={cn(
          'rounded-2xl px-4 py-3 shadow-sm transition-all duration-200',
          'bg-card border border-input text-card-foreground rounded-tl-sm'
        )}>
          <div className="flex items-center gap-3">
            <img 
              src={gifSrc}
              alt="Cargando respuesta..."
              className={cn(gifSize, 'object-contain shrink-0')}
            />
            <div className="flex flex-col">
              <span className="text-sm text-muted-foreground font-medium">
                {loadingMessage}
              </span>
              <div className="flex gap-1 mt-1">
                {[0, 150, 300].map((delay) => (
                  <span
                    key={delay}
                    className="w-1.5 h-1.5 bg-muted-foreground/40 rounded-full animate-bounce"
                    style={{ animationDelay: `${delay}ms` }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default LoadingMessageBubbleChatbot;
